export const DEFAULT_MENU = {
  admin: [
    {
      id: "876206cc-d81d-47b0-b19d-5783a37409f0",
      menuItemId: "",
      orderItem: "0",
      caption: "Dashboard",
      shortCaption: "Dash",
      path: "/admin",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "97",
      menuItemId: "",
      orderItem: "0",
      caption: "Event",
      shortCaption: "Event",
      path: "event",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Event",
          shortCaption: "Social Event",
          path: "event/social-event",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Activity - CB Course",
          shortCaption: "Social Activity",
          path: "event/social-activity",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Innovation Project",
          shortCaption: "SIP",
          path: "social-innovation-project",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
      ],
    },

    // {
    //   id: "876206cc-d81d-47b0-b19d-5783a37409f2",
    //   menuItemId: "",
    //   orderItem: "0",
    //   caption: "Community Service Activity",
    //   shortCaption: "CSA",
    //   path: "csa",
    //   icon: "",
    //   isShowListFirst: "false",
    //   isShowInGrid: "false",
    //   menuItemData: [],
    // },
    {
      id: "97",
      menuItemId: "",
      orderItem: "0",
      caption: "Recap Event",
      shortCaption: "Recap",
      path: "event",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Event",
          shortCaption: "Social Event",
          path: "recap-event/social-event",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Activity - CB Course",
          shortCaption: "Social Activity",
          path: "recap-event/social-activity",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Innovation Project",
          shortCaption: "Social Innovation",
          path: "recap-event/social-innovation-project",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },

        // {
        //   id: "876206cc-d81d-47b0-b19d-5783a37409f1",
        //   menuItemId: "",
        //   orderItem: "0",
        //   caption: "Community Service Activity",
        //   shortCaption: "CSA",
        //   path: "recap-event/csa",
        //   icon: "",
        //   isShowListFirst: "false",
        //   isShowInGrid: "false",
        //   menuItemData: [],
        // },
      ],
    },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Report",
      shortCaption: "Report",
      path: "reports",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "876206cc-d81d-47b0-b19d-5783a37409f1",
      menuItemId: "",
      orderItem: "0",
      caption: "Social Innovation Types",
      shortCaption: "SIP",
      path: "social-innovation-types",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Student Module",
      shortCaption: "Student",
      path: "master/student",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Category",
      shortCaption: "Category",
      path: "master/category",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Scale",
      shortCaption: "Scale",
      path: "master/scale",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Admin Mapping",
      shortCaption: "Admin",
      path: "master/admin",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
  ],
  student: [
    {
      id: "876206cc-d81d-47b0-b19d-5783a37409f0",
      menuItemId: "",
      orderItem: "0",
      caption: "Dashboard",
      shortCaption: "Dash",
      path: "/",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
    {
      id: "97",
      menuItemId: "",
      orderItem: "0",
      caption: "Event",
      shortCaption: "Event",
      path: "event",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Event",
          shortCaption: "Social Event",
          path: "/event/social-event",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Activity - CB Course",
          shortCaption: "Social Activity",
          path: "/event/social-activity",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
        {
          id: "876206cc-d81d-47b0-b19d-5783a37409f1",
          menuItemId: "",
          orderItem: "0",
          caption: "Social Innovation Project",
          shortCaption: "SIP",
          path: "/social-innovation-project",
          icon: "",
          isShowListFirst: "false",
          isShowInGrid: "false",
          menuItemData: [],
        },
      ],
    },
    // {
    //   id: "876206cc-d81d-47b0-b19d-5783a37409f2",
    //   menuItemId: "",
    //   orderItem: "0",
    //   caption: "Community Service Activity",
    //   shortCaption: "CSA",
    //   path: "/csa",
    //   icon: "",
    //   isShowListFirst: "false",
    //   isShowInGrid: "false",
    //   menuItemData: [],
    // },
    {
      id: "98",
      menuItemId: "",
      orderItem: "0",
      caption: "Community Service Hours",
      shortCaption: "Community Service Hours",
      path: "/score",
      icon: "",
      isShowListFirst: "false",
      isShowInGrid: "false",
      menuItemData: [],
    },
  ],
};
